<template>
  <div
    class="i-new-careers pad-wrap"
    @click="goToNewCareers"
  >
    <a class="new-careers">
      <img :src="iconGetNewCareers" />
      <div class="text">Replace</div>
    </a>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router"

import { GlobalVariables } from "@/helpers/globalVariables"

import iconGetNewCareers from "@/assets/menu/icon-get-new-careers.svg"

// ROUTES
const router = useRouter()

// FUNCTIONS
const goToNewCareers = () => {
  router.push({ name: GlobalVariables.urls.report.children.newCareers.routeName })
}
</script>

<style scoped lang="scss">
.i-new-careers {
  .new-careers {
    @include flex($direction: column, $justify: center, $align: center, $gap: 2px);

    cursor: pointer;
    margin: auto;

    @media screen and (min-width: $breakpoint-sm) {
      flex-direction: row;
      gap: 8px;
    }

    img {
      width: 18px;

      @media screen and (min-width: $breakpoint-sm) {
        align-self: start;
      }
    }

    .text {
      color: $pickle-bluewood900;

      @include text-sm;

      font-weight: 600;
    }
  }
}
</style>
